import { useBehaviourState } from '@sravni/react-silent-authentication-form';
import { useIsMobile } from '@sravni/react-utils';
import type { ComponentProps } from 'react';
import React from 'react';

import { FormStickyButton } from 'shared/ui';
import { OTPButton } from 'shared/ui/CustomAuthInlineForm/ui/OTPButton';

import { SCREENS } from '../constants';
import type { AuthInlineFormProps } from '../types';

type Props = Pick<AuthInlineFormProps, 'getOTPButtonProps' | 'isOTPButtonSticky' | 'isEnabledOTPButtonSticky'> & {
  currentScreen: ValuesOf<typeof SCREENS>;
  onClick: ComponentProps<typeof OTPButton>['onClick'];
};

export const AuthInlineFormOtpButton = (props: Props) => {
  const { getOTPButtonProps, currentScreen, onClick, isOTPButtonSticky, isEnabledOTPButtonSticky } = props;
  const { isLoading } = useBehaviourState();
  const isMobile = useIsMobile();

  const isOTPButtonLoading = isLoading && currentScreen === SCREENS.INITIAL;

  const isMobileStickyButton = !!isOTPButtonSticky && currentScreen === SCREENS.INITIAL;

  return isMobile && isEnabledOTPButtonSticky ? (
    <FormStickyButton
      enabled={isMobileStickyButton}
      ButtonComponent={
        <OTPButton
          {...getOTPButtonProps}
          loading={isOTPButtonLoading}
          onClick={onClick}
        />
      }
    />
  ) : (
    <OTPButton
      {...getOTPButtonProps}
      loading={isOTPButtonLoading}
      onClick={onClick}
    />
  );
};
